import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.overlay-footer',
        shareCta: '.overlay-footer__share',
        tooltip: '.overlay-footer__tooltip',
    },
    classNames: {
        overlayTooltipVisible: 'overlay-footer__tooltip--visible',
    },
};

export class OverlayFooter {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();
    }

    _getDomElements() {
        return {
            $shareCta: this._$rootElement.find(config.selectors.shareCta),
            $tooltip: this._$rootElement.find(config.selectors.tooltip),
        };
    }

    _addEventListeners() {
        const _this = this;

        this._elements.$shareCta.on('click', () => {
            window.navigator.clipboard.writeText(this._elements.$shareCta[0].attributes.data.value);
            const $tooltip = $(_this._elements.$tooltip);
            $tooltip.height(64);
            setTimeout(function () {
                $tooltip.height(0);
            }, 2000);
        });
    }
}

moduleRegistry.registerModule('OverlayFooter', OverlayFooter);
moduleRegistry.autoApplyModule('OverlayFooter', config.selectors.root);
